import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConnectedTableView } from '../shared/tables';
import { Link } from 'react-router-dom';
import { selectAction } from '../store/resources';

class LocationsPageView extends Component {
  render() {
    const tableConfiguration = {
      resourceName: 'locations',
      onClick: (row) => {
        this.props.selectAction('locations', row);
        this.props.history.push('/locations/' + row.id + '/update/');
      },
      definitions: {
        name: {
          title: 'Naam',
          column: true
        },
        enabled: {
          title: 'Actief',
          column: true
        }
      }
    };

    return (
      <div>
        <nav className="navbar navbar-expand navbar-light bg-light">
          <div className="navbar-brand">Locaties</div>
          <Link to="/locations/create/" className="btn btn-primary ml-auto">
            <i className="fa fa-plus mr-1" /> Locatie toevoegen
          </Link>
        </nav>
        <div className="container-fluid mt-4">
          <ConnectedTableView configuration={tableConfiguration} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectAction: (resourceName, resource) => {
    dispatch(selectAction(resourceName, resource));
  }
});

export default connect(null, mapDispatchToProps)(LocationsPageView);
